export interface IconProps {
  name: string;
}

export const Icon = ({ name }: IconProps) => {
  return <span className={`bhricon bhricon-${name}`}></span>;
};
